import actions from './actions.js';
import mutations from './mutations.js';
import stateDefaults from './state.js';

import StateMachine from '@rankers/lib/state_machine';

// A FACTORY (see the AccountPanel equivalent): the ferry-discount pane is re-injected
// each time it opens, so a module-singleton machine would accumulate a subscriber per
// host. A fresh machine per host is discarded with the host — which is now genuinely
// true: Component#destroy detaches the host and its panels from the machine (and the
// reaper calls it when the pane's DOM goes), so nothing outlives the card holding it.
// No persistentStore: only transient auth state lives here (the offer-accept
// submissions keep their own localStorage store on the host).
export default function createMemberOfferAcceptorStateMachine() {
  return new StateMachine({
    name: 'MemberOfferAcceptor',
    actions,
    mutations,
    state: { ...stateDefaults },
  });
}
